import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { Router } from 'react-router-dom'
import * as serviceWorker from './serviceWorker'
import rootSaga from './sagas'
import configureStore from './store'

import App from './App'
import './styles/styles.scss'
import { persistStore } from 'redux-persist'
import { createBrowserHistory } from 'history'

const initialState = {}
const history = createBrowserHistory()
const store = configureStore(initialState, history)
const persistor = persistStore(store)

store.runSaga(rootSaga)

const render = (Component) => {
    ReactDOM.render(
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <Router history={history}>
                    <Component />
                </Router>
            </PersistGate>
        </Provider>,
        rootAppElement
    )
}

let rootAppElement = document.getElementById('root')
if (rootAppElement) {
    render(App)
}

if (module.hot) {
    module.hot.accept('./App', () => {
        if (rootAppElement) {
            // eslint-disable-next-line
            const App = require('./App').default
            render(App)
        }
    })
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
